export const HIDDEN_NAVIGATION_ROUTES = [
  'billing-plans',
  'downloads',
  'download-success',
  'payment/success',
  'linkedin-login',
  'session-expired',
  'send-linkedin-invitations',
  'linkedin-task-manager',
  'send-linkedin-invitations?inProgress=true',
  'linkedin-task-manager?inProgress=true',
  // MFE routes: the React MFE owns the chrome on these pages.
  // The Angular header + side-nav must not render here to prevent double chrome.
  // Coordinated with the MFE AppShell (Phase 5) — both changes must deploy together.
  'dashboard',
  'campaigns',
  'leads',
  'message-templates',
  'settings',
];
